import $ from "jquery";
import jQuery from "jquery";
import Player from '@vimeo/player';
import CircleType from 'circletype';
import anime from 'animejs';
import axios from 'axios';
import AOS from 'aos';
import Vivus from 'vivus';

/** ----------------------------------------
    AOS
 ---------------------------------------- */

AOS.init();

/** ----------------------------------------
    FetchHtml
 ---------------------------------------- */

$( ".usb__item" ).on( "click", function(event) {

    /** ------------VIVUS--------------- */
    new Vivus('my-svg', {
        file: 'images/SVG/shape.svg'
    });

    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });

    $(".usb__item").each(function () {
        $(this).removeClass("active")
    });
    $(this).addClass('active');

    $( ".results" ).empty();
    const replace = document.body.querySelector('.services__header-subtitle');
    replace.innerText = event.currentTarget.innerText;

    const id = $(this).data('id');
    collectHtml('/service/' + id, '.blocks', '.results');
    $( ".services__header-title" ).empty();
    collectHtml('/service/' + id, '.services-desc', '.services__header-title');

    window.onscroll = function() {scrollFunction()};
});


function collectHtml(path, target, destination) {
    axios.get(path).then(response => {
        const html = fetchHtml({
            target: target,
            data: response.data
        });

        appendHtml({
            el: destination,
            data: html
        });
    });
}

function appendHtml(settings) {
    const el = document.querySelector(settings.el);

    const data = settings.data;
    el.insertAdjacentHTML('afterbegin', data);
}

function fetchHtml(settings) {
    const doc = document.createElement('html');
    doc.innerHTML = settings.data;

    const result = doc.querySelector(settings.target);
    return result.innerHTML;
}

$( ".usb__item" ).first().click();

/** ----------------------------------------
 Animate USB-Bar
 ---------------------------------------- */

function scrollFunction() {
    const str = window.location.href;
    const strIndex = str.indexOf("/services");

    if(strIndex>0) {
        const headerHeight = document.querySelector('.services__header').getBoundingClientRect().height;
        const usbElement = document.querySelector('.usb');

        if (document.documentElement.scrollTop > headerHeight) {
            usbElement.classList.remove('animation-not-active');
            usbElement.classList.add('animation-active');
            document.querySelector(".usb__title").style.display = 'none';
        } else {
            document.querySelector(".usb__title").style.display = 'block';
            usbElement.classList.remove('animation-active');
            usbElement.classList.add('animation-not-active');
        }
    }

}


/** ----------------------------------------
    Environment
 ---------------------------------------- */

/**
 * This class will check the current
 * environment of the website and stores
 * an object with information about the
 * current environment.
 */

import { Environment } from './Environment.js';
import { Log } from './Log.js';

const host = new Environment({
    localhost: 'vv-website-new',
    preview: 'vv-website-new',
});

const log = new Log(host);

// export for others scripts to use
window.$ = $;
window.jQuery = jQuery;

const MobileDetect = require('mobile-detect');
require('cookieconsent/build/cookieconsent.min.js');
require('imagesloaded/imagesloaded.pkgd.js');
require('malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css');
require('malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js');
require('masonry-layout/dist/masonry.pkgd.js');
require('jquery-match-height');
require('jquery-validation');
require('lity');
require('lity/dist/lity.css');
require('swiper/dist/js/swiper.jquery.min.js');
require('swiper/dist/css/swiper.min.css');
require('./vimeo_player.js');
require('./jquery.unveil.custom.js');
require('tilt.js');

$('.js-tilt').tilt({
    maxTilt:        2,
    disableAxis:    null,
    reset:          true,
    glare:          false,
    scale:          1.025
});

// set CSRF token for every AJAX request using jquery.cookie
require('jquery.cookie');
$.ajaxSetup({headers: {'X-XSRF-TOKEN': $.cookie('XSRF-TOKEN')}});

var mapStyle = [{
    "featureType": "administrative",
    "elementType": "labels.text.fill",
    "stylers": [{"color": "#444444"}]
}, {"featureType": "landscape", "elementType": "all", "stylers": [{"color": "#f2f2f2"}]}, {
    "featureType": "poi",
    "elementType": "all",
    "stylers": [{"visibility": "off"}]
}, {
    "featureType": "road",
    "elementType": "all",
    "stylers": [{"saturation": -100}, {"lightness": 45}]
}, {
    "featureType": "road.highway",
    "elementType": "all",
    "stylers": [{"visibility": "simplified"}]
}, {
    "featureType": "road.arterial",
    "elementType": "labels.icon",
    "stylers": [{"visibility": "off"}]
}, {"featureType": "transit", "elementType": "all", "stylers": [{"visibility": "off"}]}, {
    "featureType": "water",
    "elementType": "all",
    "stylers": [{"color": "#fdeb06"}, {"visibility": "on"}]
}];

var $current = $('section.content');
var $next = $('section.next');
var $next_spacer = $('.next-spacer');
var $next_indicator = $('.next-indicator');
var $window = $(window);

var next_url = null;
var current_url = null;

var md = new MobileDetect(window.navigator.userAgent);

// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
var keys = {37: 1, 38: 1, 39: 1, 40: 1};

function preventDefault(e) {
    e = e || window.event;
    if (e.preventDefault)
        e.preventDefault();
    e.returnValue = false;
}

function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
    }
}

function disableScroll() {
    if (window.addEventListener) // older FF
        window.addEventListener('DOMMouseScroll', preventDefault, false);
    window.onwheel = preventDefault; // modern standard
    window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
    window.ontouchmove = preventDefault; // mobile
    document.onkeydown = preventDefaultForScrollKeys;
}

function enableScroll() {
    if (window.removeEventListener)
        window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.onmousewheel = document.onmousewheel = null;
    window.onwheel = null;
    window.ontouchmove = null;
    document.onkeydown = null;
}
$(function () {
    window.set_next_url = function (next) {
        $next_indicator.show();

        if ($next.children().length) {
            next_url = next;
        } else {
            load_page(next);
        }
    }
});
function init_smooth_scroll($parent) {
    $parent.find('a[href*="#"]:not([href="#"])').click(function (e) {
        e.preventDefault();

        if (location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top + 25
                }, 1000);
                return false;
            }
        }
    });
}

import { Cases } from './cases/script';
const cases = new Cases();

function load_page(url) {
    current_url = url;

    if (!md.mobile()) {
        $.get(url, [], function (r) {
            $next.html(r);

            $next_spacer.prev().find('.name').html(
                $next.find('.project-header').data('title')
            );

            init_smooth_scroll($next);
            init_image_load($next);

            $window.trigger('set_sizes');
        });
    }
}
function closeMenu() {
    var items = $('.portfolio .item').get();
    $('#mCSB_1_scrollbar_vertical').removeClass('active');

    $(items).removeClass('active');
    if ($('body').hasClass('nav-main')) {
        $('body').removeClass('nav-main-animate').removeClass('nav-portfolio-animate');
        setTimeout(function () {
            $('body').removeClass('nav-main').removeClass('nav-portfolio').removeClass('nav');
        }, 300);
    }

    enableScroll();
}

function getH(items) {
    var h = 0;
    items.each(function () {
        h += $(this).outerHeight();
    });
    return h;
}

function insertNext(next, current, current_h) {
    if (current_h === undefined) {
        current_h = getH(current);
    }

    var $inserted = next.insertBefore($next_spacer);
    $next_indicator.clone().insertBefore($next_spacer);
    $next_spacer.height(0);

    setTimeout(function () {
        $inserted.filter('.project-header').find('.title')
            .addClass('active');
    }, 0);

    history.replaceState({}, "", current_url);

    // Remove previous page
    current.remove();
    $('html,body').animate({
        scrollTop: 0
    }, 0)

    $window.trigger('set_sizes');

    // Load new next page
    if (next_url) {
        var n = next_url;
        next_url = null;
        load_page(n);
        cases.reload($current);
    }
}

function timedDeferred(time) {
    var timer = $.Deferred();
    setTimeout(function () {
        timer.resolve();
    }, time);

    return timer;
}

$(function () {
    var current_h = 0;
    var next_h = 0;

    var current = $current.find('> *:not(.next-spacer)');
    var next = $next.find('> *');

    var $anchors = current.find('.anchor');

    var pt = $window.scrollTop();

    if (md.mobile()) {
        $('body').addClass('mobile');
    }

    $('.project-header .title').addClass('active');

    $(window).on('resize set_sizes', function () {
        current = $current.find('> *:not(.next-spacer)');
        next = $next.find('> *');

        $anchors = current.find('.anchor');

        current.imagesLoaded(function () {
            current_h = getH(current);
        });

        next.imagesLoaded(function () {
            next_h = getH(next);
            $next_spacer.height(next_h);
        });
    }).on('scroll set_sizes', function () {
        var t = $window.scrollTop();
        var d = t - $next_spacer.offset().top;
        var w_h = $window.height();

        var up = pt > t;
        pt = t;
        $('.scroll.back').toggleClass('active', up);

        current.find('.scroll:not(.back)').each(function () {
            var $this = $(this);
            var bottom = ($this.offset().top - t + 100);
            $this.toggleClass('active', Math.abs(w_h - bottom) < 300);
        });

        if (current_h) {
            $current.trigger('progress', Math.max(0, (d + w_h) / (current_h - w_h) + 1));

            var p = (d + w_h) / w_h;
            $current.find('.next-indicator .progress').css('width', p * 100 + '%');
            $current.find('.next-spacer').css('opacity', 1 - p);
        }

        var $header = $current.find('.nav');

        var last_anchor = null;
        $anchors.each(function () {
            if ((t + 1) > $(this).offset().top) {
                last_anchor = this.id;
            }
        });

        var u = location.href.split('#')[0];
        var new_url = last_anchor ? [u, last_anchor].join('#') : u;

        if (location.href != new_url) {
            history.replaceState({}, "", new_url);
        }

        $('.anchor-link').removeClass('active');
        if (last_anchor) {
            $('a[href="#' + last_anchor + '"]').addClass('active');
        }

        if ($header.length) {
            var h_t = $header.offset().top;
            var nav_d = t - h_t;

            if ($header.hasClass('fixed')) {
                $header.toggleClass('fixed', $header.next().offset().top - h_t < 0);
            } else {
                $header.toggleClass('fixed', nav_d >= 0);
            }
            if (screen.width < 767) {
                $('.content').css("z-index", "inherit");
            }

            var push = Math.max(0, d + w_h);
            $header.css('top', -push);
        }

        if (d > 0) {
            // Insert next page
            insertNext($next.find('> *'), current, current_h);
        }
    }).trigger("set_sizes");

    window.onpopstate = function () {
        return false;
    };

    $current.on('progress', function (e, progress) {
        $current.find('.nav .page-progress .progress').width((progress * 100) + '%');
    });

    $('.portfolio .items').mCustomScrollbar({
        axis: "y",
        theme: "dark-thick"
    });

    $('.portfolio').find('a').on('click', function () {
        $next.css('opacity', 0);
        $current.addClass('project-out');
        $('.content-loader').addClass('active');

        setTimeout(function () {
            closeMenu();
        }, 250);

        var url = $(this).attr('href');
        var get_request = $.get(url);

        current_url = url;

        $.when(get_request, timedDeferred(400)).done(function (r) {

            $current.addClass('project-load').removeClass('project-out');

            insertNext($(r[0]), $current.find('> *:not(.next-spacer)'));
            init_smooth_scroll($current);
            init_image_load($current);

            setTimeout(function () {
                $('.content-loader').removeClass('active');
                $current.removeClass('project-load');
            }, 300);

            setTimeout(function () {
                $next.css('opacity', 1);
            }, 1000);
        });

        return false;
    });

    $('a[title="Werk"], a[title="Work"]').on('click', function (e) {
        e.preventDefault();

        if ($('body').hasClass('nav-portfolio')) {
            closeMenu();
        }
        else {
            disableScroll();

            $('body').addClass('nav').addClass('nav-portfolio');

            setTimeout(function () {
                $('body').addClass('nav-portfolio-animate');
                var items = $('.portfolio .item');

                items.each(function (i, item) {
                    setTimeout(function () {
                        $(item).addClass('active');
                    }, i * 100);
                });

                setTimeout(function () {
                    $('#mCSB_1_scrollbar_vertical').addClass('active');
                }, items.length * 100 + 400);
            }, 0);
        }
    });

    // Toggle menu
    $('.menu-btn').on('click', function (e) {
        e.preventDefault();

        if ($('body').hasClass('nav-main')) {
            $('body').removeClass('nav-main-animate').removeClass('nav-portfolio-animate');

            setTimeout(function () {
                $('body').removeClass('nav-main').removeClass('nav-portfolio').removeClass('nav');
            }, 300);
        }
        else {
            $('body').addClass('nav').addClass('nav-main');

            setTimeout(function () {
                $('body').addClass('nav-main-animate');
            }, 10);
        }
    });

    // Close menu if click outside
    $(window).click(function(event) {
        const navW = 274;
        var windowW = $window.width();

        if (windowW > 768) { //xs breakpoint
            if (event.clientX > navW) {
                if ($('body').hasClass('nav-main')) {
                    $('body').removeClass('nav-main-animate').removeClass('nav-portfolio-animate');
                    setTimeout(function () {
                        $('body').removeClass('nav-main').removeClass('nav-portfolio').removeClass('nav');
                    }, 300);
                }
            }
        }
    });

    $(window).on('resize', function () {
        if ($('body').hasClass('nav-portfolio')) {
            $('body').removeClass('nav-portfolio-animate');

            setTimeout(function () {
                $('body').removeClass('nav-portfolio').removeClass('nav');
            }, 300);
        }
    });

    $('.masonry').each(function () {
        var $masonry = $(this);

        $masonry.imagesLoaded(function () {
            $masonry.masonry({
                itemSelector: '.tile'
            });
        });
    });

    init_smooth_scroll($('body'));
    init_image_load($('body'));

    $('.portfolio').on('click', function (e) {
        if (!$(e.target).closest('.items').length) {
            if ($('body').hasClass('nav-portfolio')) {
                closeMenu();
            }
        }
    });


    $('#mc-embedded-subscribe-form').on('submit', function () {
        $(this).find('button').addClass('sent');
    });

    /**
     * Nieuwsbrief form AJAX request
     */
    $('#newsletter-form').validate({
        //errorPlacement: function (error, element) {
        //},
        //highlight: function (element, errorClass) {
        //    $(element).parent().removeClass('success').addClass('error');
        //},
        //unhighlight: function (element, errorClass) {
        //    $(element).parent().removeClass('error').addClass('success');
        //},
        rules: {
            newsletter_email: {
                required: true,
                email: true
            }
        },

        submitHandler: function (form) {

            $.ajax({
                url: $(form).data('url'),
                type: 'POST',
                data: $('#newsletter-form').serialize(),
                success: function (data) {
                    $('.newsletter-container').css({
                        "margin-left": "-200%"
                    });

                    setTimeout(function () {
                        $('.newsletter-container').css({
                            "margin-left": "0%"
                        });
                    }, 3000);
                },
                error: function (data) {
                    console.log(data);

                }
            });
        }
    });

    /**
     * Contact form animation
     */
    // Displays contact form
    $('body').on('click', '.share-wrapper a#share-text', function (e) {
        e.preventDefault();

        $(".share-text").css({
            "opacity": "0",
            "height": "0",
            "padding": "0"
        });

        $("span.pull-right.icon-essential-regular-07-arrow-right").css({"display": "none"});

        $(".blocks .block.share-wrapper .share-form").css({
            "opacity": "1"
        });

        $(".share-post-left").css({
            "height": "325px",
            "padding": "40px",
            "opacity": "1"
        });
        $(".share-post-right").css({
            "height": "325px",
            "opacity": "1"
        });

        $(':input', '#share-post')
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .removeAttr('checked')
            .removeAttr('selected');

    });

    // Cancel button
    $('body').on("click", '.share-cancel', function () {
        $(".blocks .block.share-wrapper .share-form").css({
            "opacity": "0"
        });

        $(".share-post-left").css({
            "height": "0",
            "padding": "0",
            "opacity": "0"
        });
        $(".share-post-right").css({
            "height": "0",
            "opacity": "0"
        });

        $(".share-text").css({
            "opacity": "1",
            "height": "95px",
            "padding": "33px 40px"
        });
    });
});

function init_image_load($element) {
    var w = $window.width();
    var size = 'xs';

    if (w > 768) {
        size = 'sm';
    }

    if (w > 1200) {
        size = 'lg';
    }

    $element.find('[data-bg-xs][data-bg-sm][data-bg-lg]').each(function () {
        var $this = $(this);
        var url = $this.data('bg-' + size);

        var img = new Image();
        img.src = url;
        img.onload = function () {
            $this.css('background-image', "url('" + url + "')");
        };
    });

    $element.find('[data-img-xs][data-img-sm][data-img-lg]').unveil(200, function () {
        var $this = $(this);
        var url = $this.data('img-' + size);

        var img = new Image();
        img.src = url;
        img.onload = function () {
            $this.attr('src', url);
            $this.addClass('active');
        };
    });

    function setSharePost() {
        $('#share-post').validate({
            //errorPlacement: function (error, element) {
            //},
            //highlight: function (element, errorClass) {
            //    $(element).parent().removeClass('success').addClass('error');
            //},
            //unhighlight: function (element, errorClass) {
            //    $(element).parent().removeClass('error').addClass('success');
            //},
            rules: {
                to_name: {
                    required: true
                },
                from_name: {
                    required: true
                },
                to_email: {
                    required: true,
                    email: true
                },
                from_email: {
                    required: true,
                    email: true
                }
            },

            submitHandler: function (form) {

                $.ajax({
                    url: $(form).data('url'),
                    type: 'POST',
                    data: $('#share-post').serialize(),
                    success: function (data) {

                        $('#share-post').find('button[type=submit]').addClass('sent');

                        // Success...
                        $(".share-thanks").css({
                            "opacity": "1",
                            "padding": "33px 40px"
                        });

                        $(".blocks .block.share-wrapper .share-form").css({
                            "opacity": "0"
                        });

                        $(".share-post-left").css({
                            "height": "0",
                            "padding": "0",
                            "opacity": "0"
                        });
                        $(".share-post-right").css({
                            "height": "0",
                            "opacity": "0"
                        });

                        //define text
                        var text = 'Fantastisch! Hij/zij zal het waarderen!';

                        //text is split up to letters
                        $.each(text.split(''), function (i, letter) {

                            $('.share-thanks').empty();
                            //we add 100*i ms delay to each letter
                            setTimeout(function () {

                                //we add the letter to the container
                                $('.share-thanks').html($('.share-thanks').html() + letter);

                            }, 50 * i);
                        });

                        setTimeout(function () {
                            setTimeout(function () {
                                $("span.pull-right.icon-essential-regular-07-arrow-right").css({"display": "block"});
                            }, 500);
                        }, 5000)

                    },
                    error: function (data) {
                        // Error...

                        var errors = $.parseJSON(data.responseText);

                        console.log(errors);

                        $.each(errors, function (k, v) {
                            console.log(errors);
                            console.log(k);
                            console.log(v);
                            //$("#validation-output-error").append(document.createTextNode(v)).append('<br />').delay(500).fadeIn();
                        });

                    }
                });
            }
        });


    }

    /**
     * Newsletter animation
     */

    // Nieuwsbrief show form
    $element.find('.newsletter-text, .share-text').on('click', function () {
        var $active = $(this).find('.slide.active');
        var $next = $active.next();


        if ($next.length) {
            $active.removeClass('active');
            $active.addClass('inactive');
            $next.addClass('active');


            setSharePost();

            setTimeout(function () {
                $next.find('.mce-EMAIL').focus();
            }, 500);
        }
    })

    /* ----------------------------------------
        SWIPER DEFAULT
    ---------------------------------------- */

    $('.swiper-container').each(function () {
        var $swiper = $(this);
        var $first_slide = $swiper.find('.swiper-slide').first();

        $swiper.parent().css('background-color', $first_slide.data('background'));

        $swiper.swiper({
            spaceBetween: 120,
            prevButton: '.button-prev',
            nextButton: '.button-next',
            onSlideChangeStart: function (swiper) {
                var slide = swiper.slides[swiper.activeIndex];
                var $slide = $(slide);
                $swiper.parent().css('background-color', $slide.data('background'));
            }
        });

        $swiper.find('.swiper-slide').matchHeight();
    });

    /* ----------------------------------------
        SWIPER AWARDS
    ---------------------------------------- */

    $('.block.award-slider').each(function(index, value) {
        var $swiper = $(this).find('.award-swiper');
        var $prevButtonEl = $(this).find('.button-prev');
        var $nextButtonEl = $(this).find('.button-next');
        var prevClass = 'button-prev-' + index;
        var nextClass = 'button-next-' + index;

        $prevButtonEl[0].classList.add(prevClass);
        $nextButtonEl[0].classList.add(nextClass);

        $swiper.swiper({
            slidesPerView: 3,
            spaceBetween: 30,
            loop: true,
            prevButton: `.${prevClass}`,
            nextButton: `.${nextClass}`,

            breakpoints: {
                992: {
                    slidesPerView: 1,
                    spaceBetween: 10
                },
                1200: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
            }
        });

        $swiper.find('.swiper-slide').matchHeight();
    });

    /* ----------------------------------------
        SWIPER WORK
    ---------------------------------------- */

    $('.block.work-slider').each(function(index, value) {
        var $swiper = $(this).find('.work-swiper');
        var prevClass = 'work-button-prev';
        var nextClass = 'work-button-next';

        $swiper.swiper({
            spaceBetween: 120,
            pagination: '.swiper-pagination',
            paginationClickable: true,
            prevButton: `.${prevClass}`,
            nextButton: `.${nextClass}`,
            loop: true,
            breakpoints: {
                768: {
                    spaceBetween: 12
                },
                992: {
                    spaceBetween: 60
                },
                1200: {
                    spaceBetween: 90
                },
            }
        });
        $swiper.find('.swiper-slide').matchHeight();
    });

    /* ----------------------------------------
        HEADER SLIDER TIMER
    ---------------------------------------- */

    const headerSliderTimer = (duration, cycleInd) => {
        const degreesToRadians = (deg) => {
          return (deg / 360) * (2 * Math.PI);
        }
        
        let timers = document.querySelectorAll('.slider-timer');

        timers.forEach(timer => {
            let percentage = 0;
            const cycleDuration = duration;
            const interval = cycleDuration / 100; // for each percentage
            const diameter = 60;
            const strokeWidth = 20;
            const borderAround = 20;
            let canvas = document.createElement('canvas');
            let ctx = canvas.getContext('2d');
            
            timer.style.height = diameter + 'px';
            timer.style.width = diameter + 'px';
           
            canvas.classList.add('slider-timer__canvas');
            canvas.height = diameter * 2;
            canvas.width = diameter * 2;
            timer.appendChild(canvas);
            
            let center = diameter;
            let radius = center - (strokeWidth);
            let startAngle = degreesToRadians(-90);
            let fullCircle = degreesToRadians(365);
            
            const circle = (fg, bg) => {
              let endAngle = startAngle + degreesToRadians(percentage / 100 * 365);
              //bg
              ctx.strokeStyle = "rgba(1, 1, 1, 0)";
              ctx.fillStyle = bg;
              ctx.beginPath();
              ctx.arc(center, center, (radius - borderAround) * 2, degreesToRadians(-90), degreesToRadians(365));
              ctx.fill();
        
              //fg
              ctx.lineWidth = strokeWidth * 2;
              ctx.strokeStyle = fg;
              ctx.beginPath();
              ctx.arc(center, center, radius - borderAround, startAngle, endAngle);
              ctx.stroke();
            }
            
            const draw = () => {
              
              ctx.clearRect(0, 0, canvas.width, canvas.height);
              
              if (cycleInd % 2 == 0) {
                circle("white", "black")
              } else {
                circle("black", "white")
              }
            }
            
            draw()

            const loop = () => {
                draw()
                percentage++;
                if (percentage > 100) {
                  percentage = 0;
                }
            }

            const animation = setInterval(() => { loop() }, interval);
            
            setTimeout(() => {
                clearInterval(animation)
                timer.removeChild(canvas)
            }, cycleDuration);
        })
      }

    /* ----------------------------------------
        TITLE ANIMATION
    ---------------------------------------- */

    const lettersIn = el => {
        anime({
            targets: el,
            translateY: [75, 0],
            rotate: [-5, 0],
            opacity: [0, 1],
            easing: 'easeOutExpo',
            duration: 1400,
            delay: (el, i) => 300 + 30 * i
        });
    };

    // let letters = document.querySelectorAll('.block.header-slider h1 span');
    // lettersIn(letters);

    /* ----------------------------------------
        HEADER SLIDER
    ---------------------------------------- */

    const randomizePos = (block) => {
        let randAmount = 0
        window.innerWidth < 991 ? randAmount = 0 : randAmount = 30;
        let rand = [
            Math.floor(Math.random() * randAmount * 2 )- randAmount,
            Math.floor(Math.random() * randAmount * 2 )- randAmount
        ]
        setTimeout(() => {
            $(block).css('transform', `translate(${ rand[0] }px,${ rand[1] }px)`);
        }, 10);
    }

    function startHeaderSlider(headerSlider, slideBlocks) {
        headerSlider.addClass('animate-title');
        slideBlocks.each(function(index) {
            var slideBlock = $(this);
            setTimeout(() => {
                slideShow(slideBlock, index);
                randomizePos(slideBlock)
            }, 400 + 260 * index);
        });
    }

    function slideShow(slideBlock, i) {
        let timer = 0;
        var images = slideBlock.find('img');
        var activeImage = 0;

        $(images[activeImage]).addClass('active');
        
        let fadeInDuration = 0;
        let imageShownDuration = 6000;
        let fadeOutDuration = 900;

        const animateBlocks = () => {
            //change img
            $(images[activeImage]).removeClass('active');
            activeImage = (activeImage === images.length - 1) ? 0 : activeImage + 1;
            $(images[activeImage]).addClass('active');

            // in
            $(slideBlock).removeClass('animate-out');
            $(slideBlock).removeClass('animate-show');
            setTimeout(() => {
                $(slideBlock).addClass('animate-in');
            }, 10);

            

            randomizePos(slideBlock)

            // show image
            setTimeout(() => {
                $(slideBlock).addClass('animate-show');
            }, fadeInDuration);

            // out
            setTimeout(() => {
                $(slideBlock).addClass('animate-out');
                $(slideBlock).removeClass('animate-in');
                $(slideBlock).removeClass('animate-show');

            }, fadeInDuration + imageShownDuration);
        }

        setTimeout(() => {
            animateBlocks();
            
            setInterval(() => {
                animateBlocks();
            }, fadeInDuration + imageShownDuration + fadeOutDuration - 50);
        }, 300);
    }

    // Load first images of every slideshow and init header slider
    $('.block.header-slider').each(function() {        
        var headerSlider = $(this);
        var slideBlocks = $(headerSlider).find('.slide-block');
        var loaded = 0;

        // Move all images from all slideblocks into the first slideblock
        // If window is smaller then 992
        if (window.innerWidth < 992) {
            let firstWrapper = $(slideBlocks[0]).find('.wrapper');
            slideBlocks.each(function(index, value) {
                if (index === 0) return;
                $(this).find('img').each(function() {
                    $(this).appendTo(firstWrapper);
                });
            });
        }

        slideBlocks.each(function() {
            var slideBlock = $(this);
            var images = slideBlock.find('img');
            $(images[0]).imagesLoaded(function () {
                loaded++;
                if (loaded === slideBlocks.length)
                    startHeaderSlider(headerSlider, slideBlocks);
            });
        });
    });

    /* ----------------------------------------
        VIDEO BLOCK
    ---------------------------------------- */

    $('.block.video').each(function () {
        var frame = $(this);
        var player = new Vimeo.Player(frame);

        player.setVolume(0);
        player.setLoop(true);

        var iframe_top;

        $(window).on('resize', function () {
            iframe_top = frame.offset().top;
        }).trigger('resize');

        $(window).on('scroll.vimeo', function () {
            if (frame.parents('section.content').length === 1) {
                if ($(window).scrollTop() + $(window).height() > iframe_top && $(window).scrollTop() < iframe_top + frame.height()) {
                    player.play();
                } else {
                    player.pause();
                }
            }
        }).trigger('scroll');
    });

    var timeoutId;
    var $videoBgAspect = $(".home-header .videobg-aspect");
    var $videoBgWidth = $(".home-header .videobg-width");
    var videoAspect = $videoBgAspect.outerHeight() / $videoBgAspect.outerWidth();

    function videobgEnlarge() {
        let windowAspect = ($(".home-header").height() / $(".home-header").width());

        if (windowAspect > videoAspect) {
            $videoBgWidth.width((windowAspect / videoAspect) * 100 + '%');
        } else {
            $videoBgWidth.width(100 + "%")
        }
    }

    $(window).resize(function () {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(videobgEnlarge, 100);
    });

    videobgEnlarge();
}
function isInArray(value, array) {
    return array.indexOf(value) > -1;
}

$(function () {
    var $header = $('#header-video');

    if ($header.length) {
        var player = new Vimeo.Player($header.get(0));

        $(document).on('lity:open', function () {
            player.pause();
        });

        $(document).on('lity:close', function () {
            player.play();
        });
    }

    $('[data-lang]').on('click', function (e) {
        let url = window.location.pathname;     // Returns full UR
        let $this = $(this);
        let currentlang = $this.data('lang');
        let redirect = $('.redirects').data();
        console.log(redirect);
        window.location.href = redirect[currentlang];

    })
});

const circleType = new CircleType(document.getElementById('payoff'));

// newly added 20/04/2018
$(function() {
    $('.rounded-payoff').addClass('revealed');

    $('.rounded-payoff').find('span').each((index, element) => {
        let revealTimeline = anime.timeline();
        let transform = element.style.transform;
        let props = transform.split(' ');

        setTimeout(() => {
            anime({
                targets: element,
                translateX: props[0].match(/\(([^)]+)\)/)[1],
                rotate: props[1].match(/\(([^)]+)\)/)[1],
                translateY: [0, -1 + 'em'],
                delay: 1000,
                opacity: 1,
                duration: 750,
                elasticity: 500,
            });
        }, 100 * (0.5 * index));

        revealTimeline.finished.then(function(){
            // console.log('wrap it up, we are done!')
        });
    });

    var pt = 0;

    setInterval(function(){
        let old = pt;
        pt = $window.scrollTop();

        if (pt >= old && pt > 300 && pt !== old && ((pt - old) > -100)){
            $('header').removeClass('show-header').addClass('hide-header');
            $('.menu-btn').removeClass('show-menu-btn').addClass('hide-menu-btn');
        } else {
            if(pt !== old) {
                $('header').removeClass('hide-header').addClass('show-header');
                $('.menu-btn').removeClass('hide-menu-btn').addClass('show-menu-btn');
            }
        }
    }, 500);
});

// center footer columns
const centerFooterCols = () => {
    let lastColPs = $(".block.footer .column:last-child p")
    let widths = []

    Array.min = function( array ){
        return Math.min.apply( Math, array );
    };

    lastColPs.each(function() {
        let one = $(this).width();
        let two = $(this).find("a").width();
        widths.push(Math.floor(one - two));
    });

    let shortest = Array.min(widths);

    if ($window.width() > 1340) {
        $(".block.footer").css("transform", `translateX(${ shortest / 2 }px)`);
    }
}

centerFooterCols()

// Parallax effect
function simpleParallax(intensity, element) {
    if (window.innerWidth > 991) {
        $(window).scroll(function() {
            var scrollTop = $(window).scrollTop();
            var imgPos = Math.round( -(scrollTop / intensity)) + 'px';
            element.css('transform', 'translateY(' + imgPos + ')');
        });
    }
}

// simpleParallax(10, $(".parallaxFront"))
// simpleParallax(18, $(".parallaxBack1"))
// simpleParallax(14, $(".parallaxBack2"))


// WEBPACK FOOTER //
// ./resources/assets/js/index.js